function once(cb) {
  var state = {
    called: false
  };
  return function () {
    if (state.called) return;
    state.called = true;
    return cb.apply(void 0, arguments);
  };
}

export { once };
//# sourceMappingURL=once.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@headlessui/react/dist/utils/once.esm.js
// module id = 63
// module chunks = 0